export default __webpack_public_path__ + "static/media/58.d4845d76.png";